module.exports = __webpack_public_path__ + "static/media/kz-form.5d8eeab3.png";